import StorageLocal from "../../../../inc/StorageLocal";
import store from "../../../reducers/store";
import ApiModel from "../../../models/ApiModel";
import InitApp from "../../../../inc/InitApp";
import { route } from "../../../../inc/Routes";

export async function setInitData(params = {}) {
    const { 
        accessToken = null, 
        refreshToken = null, 
        permissions = [] 
    } = params;

    // Атомарное обновление Redux
    await new Promise(resolve => {
        const checkState = () => {
            const state = store.getState().app;
            if (state.accessToken === accessToken &&
                state.refreshToken === refreshToken) {
                unsubscribe();
                resolve();
            }
        };

        const unsubscribe = store.subscribe(checkState);
        InitApp.setData({
            dispatch: store.dispatch,
            accessToken,
            refreshToken,
            permissions,
            ...(accessToken && refreshToken ? InitApp.parseTokens({ accessToken, refreshToken }) : {})
        });
        checkState(); // Немедленная проверка
    });
    // Обновление хранилища
    if (params.accessToken && params.refreshToken) {
        await Promise.all([
            StorageLocal.set('ACCESS_TOKEN', params.accessToken),
            StorageLocal.set('REFRESH_TOKEN', params.refreshToken),
            StorageLocal.set('PERMISSIONS', params.permissions || [])
        ]);
        return true;
    } else {
        await Promise.all([
            StorageLocal.remove('ACCESS_TOKEN'),
            StorageLocal.remove('REFRESH_TOKEN'),
            StorageLocal.remove('PERMISSIONS')
        ]);
        return false
    }
}

export default class ApiAuth extends ApiModel {

    static isRefreshing = false;
    static pendingQueue = [];

    static resetAuthState() {
        this.pendingQueue.forEach(resolve => resolve(false));
        this.pendingQueue = [];
        this.isRefreshing = false;

        localStorage.removeItem('REFRESH_TOKEN_TS');
    }

    static async Login(params) {
        const api = new this({});
        api.login(params);
        let rdata = await api.getResponse();
        if (rdata) {
            const data = rdata.response
            return await setInitData({
                accessToken: data.access_token,
                refreshToken: data.refresh_token,
                permissions: data.permissions,
            });
        }
        this.resetAuthState();
        return false;
    }
    login(params) {
        this.__type = "POST";
        this.__path = 'public/auth/login';
        this.__params = params;
    }

    static async Logout() {
        const api = new this({});

        try {
            this.resetAuthState();
            api.logout({ access_token: api.getAccessToken() });
            await api.getResponse();
            await setInitData({});
            window.location.replace(route('/login'));
        } catch (error) {
            console.error('Logout error:', error);
            window.location.replace(route('/login'));
        }
        return false;
    }

    logout(params) {
        this.__type = "POST";
        this.__path = 'public/auth/logout';
        this.__params = params;
    }

    // не попадает в ошибку, параметры не сбрасываются
    static async RefreshToken() {

        if (this.isRefreshing) {
            return new Promise(resolve => this.pendingQueue.push(resolve));
        }

        this.isRefreshing = true;
        const api = new this({});

        try {
            await api.refreshTokenFromStorageLocal();

            api.refreshToken({
                access_token: api.getAccessToken(),
                refresh_token: api.getRefreshToken()
            });

            const rdata = await api.getResponse();
        
            if (!rdata || rdata.code === 401) {
                throw { code: 401, message: 'Invalid or expired token' };
            }

            if (!rdata.response) {
                throw new Error('Invalid refresh response');
            }

            const data = rdata.response;
            
            await setInitData({
                accessToken: data.access_token,
                refreshToken: data.refresh_token,
                permissions: data.permissions
            });

            this.pendingQueue.forEach(resolve => resolve(true));
            return true;
        } catch (error) {
                await this.Logout();
                return false;
        } finally {
            this.resetAuthState();
        }
    }

    refreshToken(params) {
        this.__type = "POST";
        this.__path = 'public/auth/refresh-token';
        this.__params = params;
    }

    async refreshTokenFromStorageLocal() {
        for (let i = 0; i < 5; i++) {
            let expAccessToken = store.getState().app.expAccessToken;
            let authData = await InitApp.authDataFromStorageLocal();

            if (authData && expAccessToken && authData.expAccessToken && expAccessToken < authData.expAccessToken) {

                InitApp.setData({ dispatch: store.dispatch, ...authData });
                return true;
            }
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        return false;
    }

    static async SendResetLinkEmail(params) {
        const api = new this({});
        api.sendResetLinkEmail(params);
        let rdata = await api.getResponse();
        if (rdata) {
            const data = rdata.response
            return true;
        }
        return false;
    }
    sendResetLinkEmail(params) {
        this.__type = "POST";
        this.__path = 'public/auth/password/email';
        this.__params = params;
    }

    static async ResetPassword(params) {
        const api = new this({});
        api.resetPassword(params);
        let rdata = await api.getResponse();
        if (rdata) {
            const data = rdata.response
            return true;
        }
        return false;
    }
    resetPassword(params) {
        this.__type = "POST";
        this.__path = 'password/reset';
        this._baseUrl = this._baseUrl.replace("/v1", "")
        this.__params = params;
    }
}
